export default {
  ALL_ITEMS: (state, data) => {
    state.all_items = data;
  },
  ITEM_CATEGORIES: (state, data) => {
    state.item_categories = data;
  },
  ITEMS: (state, data) => {
    state.items = data;
  },
  ITEM_TYPES: (state, data) => {
    state.item_types = data;
  },
  ITEM_UOM: (state, data) => {
    state.item_uom = data;
  },
  ITEM_BRAND: (state, data) => {
    state.item_brand = data;
  },
  ITEM_SIZE: (state, data) => {
    state.item_size = data;
  },
  ALL_BUNDLES: (state, data) => {
    state.all_bundles = data;
  },
  ITEM_EDIT_INFO: (state, data) => {
    state.item_edit_info = data;
  },
  STORE_ITEM: (state, data) => {
    state.store_item = data;
  },
  STORE_IMPORT_ITEM: (state, data) => {
    state.store_import_item = data;
  },
  STORE_IMPORT_IMAGE: (state, data) => {
    state.store_import_image = data;
  },
  UPDATE_IMPORT_ITEM: (state, data) => {
    state.update_import_item = data;
  },
  SHOW_ITEM: (state, data) => {
    state.show_item = data;
  },
  UPDATE_SELECTED_ITEM: (state, data) => {
    state.update_selected_item = data;
  },
  DESTROY_ITEM: (state, data) => {
    state.destroy_item = data;
  },
  STORE_ITEM_BUNDLE: (state, data) => {
    state.store_item_bundle = data;
  },
  ITEM_BUNDLE: (state, data) => {
    state.item_bundle = data;
  },
  UPDATE_ITEM_BUNDLE: (state, data) => {
    state.update_item_bundle = data;
  },
  DESTROY_ITEM_BUNDLE: (state, data) => {
    state.destroy_item_bundle = data;
  },
  ALL_ITEM_TYPES: (state, data) => {
    state.all_item_types = data;
  },
  STORE_ITEM_TYPES: (state, data) => {
    state.store_item_types = data;
    state.all_item_types = [];
  },
  SHOW_ITEM_TYPES: (state, data) => {
    state.show_item_types = data;
  },
  UPDATE_ITEM_TYPES: (state, data) => {
    state.update_item_types = data;
    state.all_item_types = [];
  },
  DESTROY_ITEM_TYPE: (state, data) => {
    state.destroy_item_types = data;
    state.all_item_types = [];
  },
  ALL_ITEM_CATEGORIES: (state, data) => {
    state.all_item_categories = data;
  },
  STORE_ITEM_CATEGORIES: (state, data) => {
    state.store_item_categories = data;
    state.all_item_categories = [];
  },
  SHOW_ITEM_CATEGORIES: (state, data) => {
    state.show_item_categories = data;
  },
  UPDATE_ITEM_CATEGORIES: (state, data) => {
    state.update_item_categories = data;
    state.all_item_categories = [];
  },
  DESTROY_ITEM_CATEGORIES: (state, data) => {
    state.destroy_item_categories = data;
    state.all_item_categories = [];
  },
  ALL_ITEM_UOM: (state, data) => {
    state.all_item_uom = data;
  },
  STORE_ITEM_UOM: (state, data) => {
    state.store_item_uom = data;
    state.all_item_uom = [];
  },
  SHOW_ITEM_UOM: (state, data) => {
    state.show_item_uom = data;
  },
  UPDATE_ITEM_UOM: (state, data) => {
    state.update_item_uom = data;
    state.all_item_uom = [];
  },
  DESTROY_ITEM_UOM: (state, data) => {
    state.destroy_item_uom = data;
    state.all_item_uom = [];
  },
  ALL_ITEM_BRAND: (state, data) => {
    state.all_item_brand = data;
  },
  STORE_ITEM_BRAND: (state, data) => {
    state.store_item_brand = data;
    state.all_item_brand = [];
  },
  SHOW_ITEM_BRAND: (state, data) => {
    state.show_item_brand = data;
  },
  UPDATE_ITEM_BRAND: (state, data) => {
    state.update_item_brand = data;
    state.all_item_brand = [];
  },
  DESTROY_ITEM_BRAND: (state, data) => {
    state.destroy_item_brand = data;
    state.all_item_brand = [];
  },
  ALL_ITEM_SIZES: (state, data) => {
    state.all_item_sizes = data;
  },
  STORE_ITEM_SIZES: (state, data) => {
    state.store_item_sizes = data;
    state.all_item_sizes = [];
  },
  SHOW_ITEM_SIZES: (state, data) => {
    state.show_item_sizes = data;
  },
  UPDATE_ITEM_SIZES: (state, data) => {
    state.update_item_sizes = data;
    state.all_item_sizes = [];
  },
  DESTROY_ITEM_SIZES: (state, data) => {
    state.destroy_item_sizes = data;
    state.all_item_sizes = [];
  },
  ITEM_SUBSTITUTION: (state, data) => {
    state.item_substitution = data;
  },
  showExportItemModal(state) {
    state.exportItemModal = true;
  },
  showImportItemModal(state) {
    state.importItemModal = true;
  },
  closeExportItemModal(state) {
    state.exportItemModal = false;
  },
  closeImportItemModal(state) {
    state.importItemModal = false;
  },
  EXP_ITEM_MASTER: (state, data) => {
    state.export_item_master_to_excel = data;
  },
  ITEM_TEMPLATE: (state, data) => {
    state.item_template = data;
  },
  ITEM_TEMPLATE_SELECTION: (state, data) => {
    state.item_template_selection = data;
  },
  ITEM_TEMPLATE_DETAILS: (state, data) => {
    state.item_template_details = data;
  },
  SAMPLE: (state, data) => {
    state.test = data;
  },
  is_sp(state) {
    state.is_sp = true;
  },
  PARTS_COMPATIBILITY: (state, data) => {
    state.parts_compatibility = data;
  },
  ITEM_TEMP_LIST: (state, data) => {
    state.item_temp_list = data;
  },
  ITEM_CHANGES: (state, data) => {
    state.item_changes = data;
  },
  ITEM_APPROVAL_DIALOG: (state, data) => {
    state.item_approval_dialog = data;
  },
  SELECTED_ITEM_TEMP: (state, data) => {
    state.selected_item_temp = data;
  },
  CAN_BYPASS_ITEM_APPROVAL: (state, data) => {
    state.can_bypass_item_approval = data;
  },
  CAN_APPROVE_ITEM_CHANGES: (state, data) => {
    state.can_approve_item_changes = data;
  },
  ITEM_APPROVAL_SETTINGS: (state, data) => {
    state.item_approval_settings = data;
  },
};
